import React from "react";
import AboutMe from "../../assets/images/about/about-1.jpeg";
import Resume from '../../assets/resume.pdf';

const About = () => {
  return (
    <>
      <section className="about-style-one space-y-top">
        <div className="container">
          <div className="row gy-4 gx-4">
            <div className="col-lg-5">
              <div className="author-image wow fadeInDown" data-wow-delay="0.3s">
                <img src={AboutMe} alt="author image" className="w-100" />
              </div>
            </div>
            <div className="col-lg-7">
              <div className="about-content pt-4">
                <div className="section-heading">
                  <span>Where I</span>
                  <h2>
                    Turn Ideas <br />
                    Into Interfaces
                  </h2>
                </div>
                <p>
                  I am a seasoned User Interface Design and Development expert
                  with over 9 years experience crafting intuitive, accessible
                  and visually compelling digital experiences. My expertise
                  bridges the gap between design and technology, combining a
                  deep understanding of human-centered design principles with
                  strong front-end development skills. I specialize in creating
                  responsible, scalable interfaces using modern frameworks like
                  React and Flutter, ensuring seamless usability across devices
                  and platforms. I process good skills in HTML, CSS, JS and
                  Responsive Designing. I closely collaborate with
                  cross-functional teams enabling user-focused solutions to life
                  on fresh or existing application products, I thrive on
                  presenting elegant and user-friendly interfaces easing
                  complex-challenges.
                </p>
                <div className="about__btn d-flex gap-4 flex-wrap align-items-center">
                  <a
                    href={Resume}
                    download="resume"
                    title="download Cv"
                    className="btn-rounded-lg"
                  >
                    <span>Download CV</span>
                  </a>
                  <div className="">
                    <a
                      href="#skills"
                      title="Explore Case Studies"
                      className="btn-border-border"
                    >
                      my skills
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
